import './manual-pull-log.component.scss'
import {NewManualImportDialog} from "../new_manual_import_dialog/new-manual-import.dialog";
import {IMessage} from "@stomp/stompjs";
import {LogItem} from "../../model/LogItem";
import {ReportLog} from "../../model/ReportLog";
import {ManualImportServiceName} from "../../../utils/names/serviceNames";
import {ManualImportService} from "../../services/ManualImportService";

export interface ManualImportComponentScope {
    logs: ReportLog[]
    logItems: LogItem[]
    openNewLqbImportDialog: () => void;
}

export class ManualPullLogComponent {
    static instance = {
        controller: [
            '$scope',
            '$mdDialog',
            ManualImportServiceName,
            ManualPullLogComponent
        ],
        template: require("./manual-pull-log.component.html"),
        bindings: {
            logs: '<'
        }
    };

    constructor(private $scope: ManualImportComponentScope,
                private $mdDialog: angular.material.IDialogService,
                private manualImportService: ManualImportService) {
        this.$scope.openNewLqbImportDialog = this.openNewLqbImportDialog;
    }


    $onInit() {
        this.manualImportService.startImportLogsSession(this.handleImportUpdate);
    }

    handleImportUpdate = (message: IMessage) => {
        let update = <ReportLog[]>JSON.parse(message.body);
        console.log('Recieved log update! ');
        console.log(update);
        update.forEach(log => this.addOrUpdate(log));

    };

    addOrUpdate = (log: ReportLog) => {
        let foundLogIndex = this.findLogIndex(log);
        if (foundLogIndex === -1) {
            this.addToScope(log);
        } else {
            let logItem = this.$scope.logItems[foundLogIndex];
            Object.assign(logItem.log, log);
            logItem.logSubject.next(log);
        }
    };

    private findLogIndex = (log: ReportLog) => {
        return this.$scope.logItems.findIndex(l => l.log.id === log.id);
    };

    openNewLqbImportDialog = () => {
        this.$mdDialog.show(NewManualImportDialog.instance);
    };

    addToScope = (log: ReportLog) => {
        this.$scope.logItems.unshift(new LogItem(log));
    };

    $onChanges(onChangesObj: angular.IOnChangesObject): void {
        let changeObj = onChangesObj['logs'];
        if (changeObj && !changeObj.isFirstChange()) {
            this.$scope.logs = changeObj.currentValue;
            this.$scope.logItems = this.$scope.logs.map(log => new LogItem(log));
        }
    }

    $onDestroy() {
        this.manualImportService.stopImportLogsSession();
    }
}